// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'

export default createVuetify({
  defaults: {
    global: {
      style: {
        fontFamily: 'Open Sans, sans-serif',
      },
    },
  },
})